// Shrinking sticky header — only shrinks after scrolling past the header
(function () {
  const THRESHOLD = 80;
  function updateHeader() {
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    const section = wrapper.closest('.shopify-section');
    const shrink = window.scrollY > THRESHOLD;
    wrapper.classList.toggle('bc-header-shrunk', shrink);
    // Also collapse the section's schema padding (inline style)
    if (section) {
      section.style.paddingTop = shrink ? '0' : '';
      section.style.paddingBottom = shrink ? '0' : '';
    }
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();
})();

// Product page — image variant swatches
(function () {
  function skuRegex(sku) {
    var escaped = sku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(escaped + '_(\\d+)', 'i');
  }

  // Highest-N {SKU}_{N} image — used for the swatch button thumbnail
  function findSwatchImage(sku, images) {
    if (!sku) return null;
    var pattern = skuRegex(sku);
    var best = null, bestN = -1;
    images.forEach(function (img) {
      var m = img.url.match(pattern);
      if (m) { var n = parseInt(m[1], 10); if (n > bestN) { bestN = n; best = img; } }
    });
    return best;
  }

  // Lowest-N {SKU}_{N} image — shown as main gallery image when swatch is clicked
  function findPrimaryImage(sku, images) {
    if (!sku) return null;
    var pattern = skuRegex(sku);
    var best = null, bestN = Infinity;
    images.forEach(function (img) {
      var m = img.url.match(pattern);
      if (m) { var n = parseInt(m[1], 10); if (n < bestN) { bestN = n; best = img; } }
    });
    return best;
  }

  // Replace each swatch button's content with its image.
  // Primary source: highest-N SKU filename match from the images JSON island.
  // Fallback: data-swatch-src (the variant's featured_image URL, embedded at render time).
  function updateSwatchImages(images) {
    document.querySelectorAll('.bc-swatch').forEach(function (swatch) {
      var match = findSwatchImage(swatch.dataset.sku, images);
      var src = match ? match.url : (swatch.dataset.swatchSrc || '');
      var alt = match ? (match.alt || '') : (swatch.title || '');
      if (!src) return;
      var img = swatch.querySelector('img');
      if (img) {
        img.src = src;
        if (alt) img.alt = alt;
      } else {
        var span = swatch.querySelector('.bc-swatch-text');
        if (span) swatch.removeChild(span);
        var newImg = document.createElement('img');
        newImg.src = src;
        newImg.alt = alt;
        newImg.loading = 'lazy';
        swatch.appendChild(newImg);
      }
    });
  }

  // Preload each variant's {SKU}_1 using the gallery slide's actual src for an exact cache hit
  function preloadPrimaryImages(images) {
    var mediaGallery = document.querySelector('media-gallery');
    var productInfo  = document.querySelector('product-info');
    var sectionId    = productInfo && productInfo.dataset.section;
    var seen = {};
    document.querySelectorAll('.bc-swatch[data-sku]').forEach(function (swatch) {
      var sku = swatch.dataset.sku;
      if (!sku || seen[sku]) return;
      seen[sku] = true;
      var primary = findPrimaryImage(sku, images);
      if (!primary) return;
      var preloadUrl = primary.url;
      if (mediaGallery && sectionId) {
        var slide = mediaGallery.querySelector('[data-media-id="' + sectionId + '-' + primary.id + '"]');
        var slideImg = slide && slide.querySelector('img');
        if (slideImg && slideImg.src) preloadUrl = slideImg.src;
      }
      new Image().src = preloadUrl;
    });
  }

  // Switch gallery only once the target image is downloaded — old image stays visible during fetch
  function switchWhenReady(gallery, mediaId) {
    var done = false;
    function go() {
      if (done) return;
      done = true;
      gallery.setActiveMedia(mediaId, true);
    }

    var slide = gallery.querySelector('[data-media-id="' + mediaId + '"]');
    var img = slide && slide.querySelector('img');

    if (!img) { go(); return; }
    if (img.complete && img.naturalWidth > 0) { go(); return; }

    var probeUrl = img.src;
    if (probeUrl) {
      var probe = new Image();
      probe.addEventListener('load', go, { once: true });
      probe.addEventListener('error', go, { once: true });
      probe.src = probeUrl;
      if (probe.complete && probe.naturalWidth > 0) go();
    } else {
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', go, { once: true });
    }
  }

  var priceObserver = null;

  // Click handler
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.bc-swatch');
    if (!swatch) return;

    // Active state
    var row = swatch.closest('.bc-swatch-row');
    if (row) {
      row.querySelectorAll('.bc-swatch').forEach(function (s) { s.classList.remove('bc-swatch--active'); });
    }
    swatch.classList.add('bc-swatch--active');

    var mediaGallery = document.querySelector('media-gallery');
    var productInfo  = document.querySelector('product-info');
    var sectionId    = productInfo && productInfo.dataset.section;

    var dataEl = document.querySelector('.bc-product-images-data');
    var images;
    if (dataEl && swatch.dataset.sku) {
      try { images = JSON.parse(dataEl.textContent); } catch (_) {}
    }
    var primary = images ? findPrimaryImage(swatch.dataset.sku, images) : null;

    // Switch to {SKU}_1 only once its image is ready — no blank while downloading
    if (mediaGallery && sectionId && primary && primary.id) {
      switchWhenReady(mediaGallery, sectionId + '-' + primary.id);
    }

    // Sync Dawn's variant picker so price/availability/cart update via its XHR.
    // Handles both dropdown <select> (default picker) and radio/pill inputs (button picker).
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var optionVals = [swatch.dataset.option1, swatch.dataset.option2, swatch.dataset.option3];
      var lastChanged = null;

      // Dropdown selects — set value + attribute so getAllSelectedOptions() reads correctly
      variantSelects.querySelectorAll('select').forEach(function (sel, i) {
        var targetVal = optionVals[i];
        if (!targetVal) return;
        Array.from(sel.options).forEach(function (o) { o.removeAttribute('selected'); });
        var match = Array.from(sel.options).find(function (o) { return o.value === targetVal; });
        if (match) { match.setAttribute('selected', 'selected'); sel.value = targetVal; lastChanged = sel; }
      });

      // Radio / pill buttons (0-indexed: Option-{sectionId}-0, -1, -2)
      optionVals.forEach(function (val, i) {
        if (!val) return;
        variantSelects.querySelectorAll('input[name$="-' + i + '"]').forEach(function (radio) {
          if (radio.value === val) { radio.checked = true; lastChanged = radio; }
        });
      });

      if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Directly update the hidden variant ID input so cart always submits the correct variant,
    // regardless of whether Dawn's async XHR chain completes in time.
    var variantId = swatch.dataset.variantId;
    if (variantId) {
      document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
        input.value = variantId;
      });
    }

    // Immediately reflect OOS state — don't wait for Dawn's async XHR.
    var isUnavailable = swatch.classList.contains('bc-swatch--unavailable');
    if (sectionId) {
      var submitBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (submitBtn) {
        var btnSpan = submitBtn.querySelector('span');
        if (isUnavailable) {
          submitBtn.setAttribute('disabled', 'disabled');
          if (btnSpan) btnSpan.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
        } else {
          submitBtn.removeAttribute('disabled');
          if (btnSpan) btnSpan.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
        }
      }
    }
    var paymentBtn = document.querySelector('.shopify-payment-button');
    if (paymentBtn) paymentBtn.style.display = isUnavailable ? 'none' : '';

    // Dawn's XHR calls setActiveMedia(featured_media_id) after fetch, overriding our {SKU}_1.
    // Watch the price element — Dawn updates it right after updateMedia — then re-apply ours.
    if (mediaGallery && sectionId && primary && primary.id) {
      if (priceObserver) priceObserver.disconnect();
      var priceEl = document.getElementById('price-' + sectionId);
      if (priceEl) {
        var _gallery = mediaGallery;
        var _mediaId = sectionId + '-' + primary.id;
        priceObserver = new MutationObserver(function () {
          priceObserver.disconnect();
          priceObserver = null;
          _gallery.setActiveMedia(_mediaId, false);
        });
        priceObserver.observe(priceEl, { subtree: true, childList: true, characterData: true });
      }
    }
  });

  // Thumbnail click → activate the matching swatch + sync Dawn's price/availability
  document.addEventListener('click', function (e) {
    var thumbBtn = e.target.closest('.thumbnail-list .thumbnail');
    if (!thumbBtn) return;

    var thumbItem = thumbBtn.closest('[data-target]');
    if (!thumbItem) return;

    var productInfo = document.querySelector('product-info');
    var sectionId   = productInfo && productInfo.dataset.section;
    if (!sectionId) return;

    var target = thumbItem.dataset.target; // "{sectionId}-{mediaId}"
    if (!target.startsWith(sectionId + '-')) return;
    var mediaId = target.slice(sectionId.length + 1);

    var dataEl = document.querySelector('.bc-product-images-data');
    if (!dataEl) return;
    var images;
    try { images = JSON.parse(dataEl.textContent); } catch (_) { return; }

    // Find the image in the JSON island by its ID
    var clickedImage = null;
    images.forEach(function (img) { if (String(img.id) === mediaId) clickedImage = img; });
    if (!clickedImage) return;

    // Find the swatch whose SKU pattern matches the clicked image URL
    var matchedSwatch = null;
    document.querySelectorAll('.bc-swatch[data-sku]').forEach(function (swatch) {
      if (matchedSwatch) return;
      if (skuRegex(swatch.dataset.sku).test(clickedImage.url)) matchedSwatch = swatch;
    });
    if (!matchedSwatch) return;

    // Activate the matched swatch
    var row = matchedSwatch.closest('.bc-swatch-row');
    if (row) row.querySelectorAll('.bc-swatch').forEach(function (s) { s.classList.remove('bc-swatch--active'); });
    matchedSwatch.classList.add('bc-swatch--active');

    // Sync Dawn's variant picker so price/availability updates via its XHR.
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var optionVals = [matchedSwatch.dataset.option1, matchedSwatch.dataset.option2, matchedSwatch.dataset.option3];
      var lastChanged = null;

      variantSelects.querySelectorAll('select').forEach(function (sel, i) {
        var targetVal = optionVals[i];
        if (!targetVal) return;
        Array.from(sel.options).forEach(function (o) { o.removeAttribute('selected'); });
        var match = Array.from(sel.options).find(function (o) { return o.value === targetVal; });
        if (match) { match.setAttribute('selected', 'selected'); sel.value = targetVal; lastChanged = sel; }
      });

      optionVals.forEach(function (val, i) {
        if (!val) return;
        variantSelects.querySelectorAll('input[name$="-' + i + '"]').forEach(function (radio) {
          if (radio.value === val) { radio.checked = true; lastChanged = radio; }
        });
      });

      if (lastChanged) lastChanged.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Dawn's XHR will switch the gallery to featured_media — re-apply the clicked image instead
    var mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && sectionId) {
      if (priceObserver) priceObserver.disconnect();
      var priceEl = document.getElementById('price-' + sectionId);
      if (priceEl) {
        var _gallery   = mediaGallery;
        var _mediaId   = target; // keep gallery on what the user clicked
        priceObserver = new MutationObserver(function () {
          priceObserver.disconnect();
          priceObserver = null;
          _gallery.setActiveMedia(_mediaId, false);
        });
        priceObserver.observe(priceEl, { subtree: true, childList: true, characterData: true });
      }
    }
  });

  // Hide highest-N image from the gallery (viewer + thumbnails) for each SKU where highest != lowest
  function filterGalleryHighestN(images, sectionId) {
    if (!sectionId) return;
    var mediaGallery = document.querySelector('media-gallery');
    var thumbList = document.querySelector('.thumbnail-list');
    var seen = {};

    document.querySelectorAll('.bc-swatch[data-sku]').forEach(function (swatch) {
      var sku = swatch.dataset.sku;
      if (!sku || seen[sku]) return;
      seen[sku] = true;

      var highest = findSwatchImage(sku, images);
      var lowest  = findPrimaryImage(sku, images);
      if (!highest || !lowest || highest.id === lowest.id) return;

      var mediaId = sectionId + '-' + highest.id;

      // Hide the main viewer slide
      if (mediaGallery) {
        var slide = mediaGallery.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) (slide.closest('li') || slide).classList.add('bc-gallery-hidden');
      }

      // Thumbnail <li> items use data-target="{sectionId}-{mediaId}" to link to viewer slides
      if (thumbList) {
        var thumbEl = thumbList.querySelector('[data-target="' + mediaId + '"]');
        if (thumbEl) thumbEl.classList.add('bc-gallery-hidden');
      }
    });

    // Ensure the gallery starts on the lowest-N for the default variant, not the now-hidden highest-N
    if (mediaGallery) {
      var initSwatch = document.querySelector('.bc-swatch--active[data-sku]');
      if (initSwatch) {
        var initPrimary = findPrimaryImage(initSwatch.dataset.sku, images);
        if (initPrimary && initPrimary.id) {
          switchWhenReady(mediaGallery, sectionId + '-' + initPrimary.id);
        }
      }
    }
  }

  // On load: set swatch button images to highest-N SKU match and preload primary images
  function init() {
    var dataEl = document.querySelector('.bc-product-images-data');
    if (!dataEl) return;
    var images;
    try { images = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var productInfo = document.querySelector('product-info');
    var sectionId   = productInfo && productInfo.dataset.section;
    updateSwatchImages(images);
    preloadPrimaryImages(images);
    filterGalleryHighestN(images, sectionId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Product gallery — 2-row thumbnail grid with +N overflow
(function () {
  var COLS = 4;
  var ROWS = 2;
  var MAX_VISIBLE = COLS * ROWS; // 8 thumbnails before overflow kicks in

  function initGalleryThumbs() {
    // Only apply on desktop
    if (window.innerWidth < 750) return;

    var thumbList = document.querySelector('.thumbnail-list');
    if (!thumbList) return;

    var items = Array.from(thumbList.querySelectorAll(':scope > .thumbnail-list__item:not(.bc-gallery-hidden)'));
    if (items.length <= MAX_VISIBLE) return;

    // Items from index [MAX_VISIBLE - 1] onward are hidden; their slot becomes "+N"
    var hiddenItems = items.slice(MAX_VISIBLE - 1);
    var overflowCount = hiddenItems.length;

    hiddenItems.forEach(function (item) {
      item.classList.add('bc-thumb-hidden');
    });

    // Insert "+N" button in the slot vacated by the first hidden item
    var moreItem = document.createElement('li');
    moreItem.className = 'thumbnail-list__item bc-thumb-more-item';
    moreItem.innerHTML = '<button class="bc-thumb-more" type="button">+' + overflowCount + '</button>';
    hiddenItems[0].insertAdjacentElement('beforebegin', moreItem);

    moreItem.querySelector('.bc-thumb-more').addEventListener('click', function () {
      hiddenItems.forEach(function (item) {
        item.classList.remove('bc-thumb-hidden');
      });
      moreItem.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryThumbs);
  } else {
    initGalleryThumbs();
  }
})();

// Product page — convert structured description into accordion
(function () {
  var SECTIONS = [
    { key: 'WHY WE LOVE IT',  label: 'Why We Love It' },
    { key: 'HOW TO APPLY',    label: 'How To Apply'   },
    { key: 'HOW TO USE',      label: 'How To Use'     },
    { key: 'SPECIFICATIONS',  label: 'How To Apply'   },
    { key: 'INGREDIENTS',     label: 'Ingredients'    }
  ];

  // Convert paragraphs containing • into proper <ul><li> lists
  function normalizeBullets(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;

    tmp.querySelectorAll('p').forEach(function (p) {
      if (!p.textContent.includes('•')) return;

      // Normalise <br> to • so we handle both inline and line-break separated bullets
      var raw = p.innerHTML.replace(/<br\s*\/?>/gi, '•');
      var items = raw.split('•')
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; });

      if (items.length < 2) return;

      var ul = document.createElement('ul');
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.innerHTML = item;
        ul.appendChild(li);
      });
      p.parentNode.replaceChild(ul, p);
    });

    // Merge adjacent <ul> elements into one
    tmp.querySelectorAll('ul + ul').forEach(function (ul) {
      var prev = ul.previousElementSibling;
      while (ul.firstChild) prev.appendChild(ul.firstChild);
      ul.parentNode.removeChild(ul);
    });

    return tmp.innerHTML;
  }

  function makeAccordionItem(label, bodyHTML) {
    return '<details class="bc-accordion-item">'
      + '<summary class="bc-accordion-header">'
      +   '<span>' + label + '</span>'
      +   '<svg class="bc-accordion-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'
      +     '<polyline points="6 9 12 15 18 9"></polyline>'
      +   '</svg>'
      + '</summary>'
      + '<div class="bc-accordion-body">' + bodyHTML + '</div>'
      + '</details>';
  }

  function buildAccordion() {
    var descEl = document.querySelector('.product__description');
    if (!descEl) return;

    var children = Array.from(descEl.children);
    if (!children.length) return;

    // ---- Pass 1: section headings are separate child elements ----
    var splits = [];
    children.forEach(function (el, i) {
      var raw = el.textContent.trim().toUpperCase().replace(/:$/, '').trim();
      SECTIONS.forEach(function (s) {
        if (raw === s.key || raw.startsWith(s.key + ':') || raw.startsWith(s.key + ' ')) {
          splits.push({ index: i, key: s.key, label: s.label });
        }
      });
    });

    if (splits.length) {
      var introHTML = children.slice(0, splits[0].index).map(function (el) { return el.outerHTML; }).join('');
      var accordionHTML = splits.map(function (split, i) {
        var endIdx = splits[i + 1] ? splits[i + 1].index : children.length;
        var headingEl = children[split.index];
        var keyPattern = new RegExp('^' + split.key + ':?\\s*', 'i');
        var inlineContent = headingEl.textContent.trim().replace(keyPattern, '').trim();
        var bodyHTML = (inlineContent ? '<p>' + inlineContent + '</p>' : '')
          + children.slice(split.index + 1, endIdx).map(function (el) { return el.outerHTML; }).join('');
        bodyHTML = normalizeBullets(bodyHTML);
        return makeAccordionItem(split.label, bodyHTML);
      }).join('');
      descEl.innerHTML = introHTML + '<div class="bc-accordion">' + accordionHTML + '</div>';
      return;
    }

    // ---- Pass 2: sections are inline within a single paragraph ----
    // Normalise encoded <br> text and real <br> tags to spaces so we can
    // treat the whole content as a flat text string for splitting.
    var html = descEl.innerHTML
      .replace(/&lt;br\s*\/?&gt;/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ');

    var escapedKeys = SECTIONS.map(function (s) {
      return s.key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    var headingRe = new RegExp('(' + escapedKeys.join('|') + ')\\s*:', 'gi');

    var inlineSplits = [];
    var m;
    while ((m = headingRe.exec(html)) !== null) {
      var matchedKey = m[1].trim().toUpperCase();
      SECTIONS.forEach(function (s) {
        if (s.key === matchedKey) {
          inlineSplits.push({ start: m.index, contentStart: m.index + m[0].length, label: s.label });
        }
      });
    }

    if (!inlineSplits.length) return;

    var introRaw = html.slice(0, inlineSplits[0].start).trim().replace(/<\/?\w[^>]*>/g, '').trim();
    var introHTML = introRaw ? '<p>' + introRaw + '</p>' : '';

    var accordionHTML2 = inlineSplits.map(function (split, i) {
      var end = inlineSplits[i + 1] ? inlineSplits[i + 1].start : html.length;
      var bodyText = html.slice(split.contentStart, end).replace(/<\/?\w[^>]*>/g, '').trim();
      var bodyHTML = normalizeBullets('<p>' + bodyText + '</p>');
      return makeAccordionItem(split.label, bodyHTML);
    }).join('');

    descEl.innerHTML = introHTML + '<div class="bc-accordion">' + accordionHTML2 + '</div>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildAccordion);
  } else {
    buildAccordion();
  }
})();

// Swap card image when a variant is selected
document.addEventListener('change', function (e) {
  if (!e.target.matches('.bc-card-variant-select')) return;

  const select = e.target;
  const option = select.options[select.selectedIndex];
  const newSrc = option.dataset.image || select.dataset.defaultImage;

  if (!newSrc) return;

  const card = select.closest('.card-wrapper');
  if (!card) return;

  const img = card.querySelector('.card__media img');
  if (!img) return;

  img.src = newSrc;
  img.srcset = newSrc + ' 533w';
  if (option.dataset.imageAlt) img.alt = option.dataset.imageAlt;
});
